import { render, staticRenderFns } from "./_company.vue?vue&type=template&id=16d30cf4&scoped=true&"
import script from "./_company.vue?vue&type=script&lang=js&"
export * from "./_company.vue?vue&type=script&lang=js&"
import style0 from "./_company.vue?vue&type=style&index=0&id=16d30cf4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d30cf4",
  null
  
)

export default component.exports